import type { Theme } from '@emotion/react';
import { buildTheme } from 'common-ui';
import merge from 'lodash/merge';
import type { CommonThemeVars, ThemeCreateFunction } from 'tsconfig/types';
import { buildThemeVarsSTWC, buildThemeMixinsSTWC, buildThemeWidgetStylesSTWC } from 'dw-uk-stwc/theme';

const createTheme: ThemeCreateFunction = () =>
  buildTheme(
    (vars: Pick<Theme, CommonThemeVars>) => merge({}, buildThemeVarsSTWC(vars)),
    buildThemeMixinsSTWC,
    (vars: Omit<Theme, 'widgets'>) => merge({}, buildThemeWidgetStylesSTWC(vars)),
  );

export default createTheme;
